/**
 * @file AddRelatedRecord.jsx
 * @description AddRelatedRecord component for adding related records to customers.
 * @component AddRelatedRecord
 * @exports AddRelatedRecord - Main component for adding related records to customers.
 */

import React, { useState } from "react";
import AddRelatedRecordModel from "../incoming/AddRelatedRecordModel";

const AddRelatedRecord = ({ customerguid }) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<div style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
				Add Related Record
			</div>
			{open && (
				<AddRelatedRecordModel
					open={open}
					onClose={() => setOpen(false)}
					customerguid={customerguid}
				/>
			)}
		</>
	);
};

export default AddRelatedRecord;
